export default __webpack_public_path__ + "static/media/Kids.853cf26b.png";